/**
 * Savings Redux Slice
 */
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { get, post } from '../../services/api/axiosInstance';
import { API_ENDPOINTS } from '../../services/api/apiEndpoints';

export const fetchSavings = createAsyncThunk(
  'savings/fetchAll',
  async (params, { rejectWithValue }) => {
    try {
      const response = await get(API_ENDPOINTS.SAVINGS.BASE, params);
      return response;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message);
    }
  }
);

export const createSavingsAccount = createAsyncThunk(
  'savings/create',
  async (data, { rejectWithValue }) => {
    try {
      const response = await post(API_ENDPOINTS.SAVINGS.BASE, data);
      return response;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message);
    }
  }
);

const savingsSlice = createSlice({
  name: 'savings',
  initialState: {
    accounts: [],
    isLoading: false,
    error: null,
  },
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchSavings.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchSavings.fulfilled, (state, action) => {
        state.isLoading = false;
        state.accounts = action.payload.data || action.payload;
      })
      .addCase(fetchSavings.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      });
  },
});

export const { clearError } = savingsSlice.actions;
export default savingsSlice.reducer;
